import _ from 'lodash';
import $ from 'jquery';
import React, { Component, Fragment } from 'react';
import classnames from 'classnames';

export default class NavTab extends Component {
  state = {
    value: undefined,
  };
  reloadTab = _.debounce(() => {
    var $el, leftPos, newWidth;
    var tabsUl = _.first($('.basic-tabs-label ul'));
    if (!tabsUl) return;
    var $magicLine = _.first($(tabsUl).find('#magic-line'));
    if (!$magicLine) {
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>");
    }
    $magicLine = _.first($(tabsUl).find('#magic-line'));

    if (!$magicLine) return;

    $magicLine = $('#magic-line');

    $magicLine.width($('.current_page_item').width());
    // $current_page_item = $(".current_page_item a")

    if (_.isFunction($('.current_page_item a').position)) {
      $magicLine.css(
        'left',
        _.get($('.current_page_item a').position(), 'left', 0)
      );
    }

    $magicLine
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width());

    $(document).on(
      {
        mouseenter: function() {
          $el = $(this);
          leftPos = $el.position().left;
          newWidth = $el.parent().width();

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          });
        },
        mouseleave: function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          });
        },
      },
      '.basic-tabs-label ul li a'
    );

    $(document).on(
      {
        mouseenter: function() {
          if (!$(this).hasClass('highlight')) {
            $('.highlight').removeClass('current_page_item');
          }
        },
        mouseleave: function() {
          $('.highlight').addClass('current_page_item');
        },
      },
      '#pills-tab .nav-item'
    );
  }, 10);

  static getDerivedStateFromProps(props, state) {
    if (props.value !== state.value) return { value: props.value };
  }
  componentDidMount = () => {
    this.reloadTab();
  };
  componentDidUpdate = (prevProps, prevState, snapshot) => {
    // console.log('componentDidUpdate', prevProps, prevState, this.state)
    if (prevState.value !== this.state.value) {
      this.reloadTab();
    }
  };
  render() {
    return (
      <Fragment>
        <div class='mt-4'>
          <div class='mb-5 basic-tabs-label'>
            <ul class='nav nav-pills' id='pills-tab'>
              {_.map(_.get(this, 'props.tabs', []), (item) => (
                <li
                  className={classnames(
                    'nav-item',
                    item.value === this.state.value
                      ? 'current_page_item highlight'
                      : null
                  )}
                  key={item.type}
                >
                  <a
                    className={classnames('nav-link')}
                    href={_.get(item, 'link')}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ value: item.value }, () => {
                        this.reloadTab();
                        if (this.props.onChange) {
                          this.props.onChange(item.value, item);
                        }
                      });
                      this.reloadTab();
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
              {/* <li class="nav-item current_page_item highlight"><a class="nav-link" href="#">分店資訊</a></li>
              <li class="nav-item"><a class="nav-link" href="#">美食餐廳</a></li>
              <li class="nav-item"><a class="nav-link" href="#">專櫃介紹</a></li> */}
              <li id='magic-line' />
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavTab/NavTab.js